export default "__VITE_ASSET__CcSNe_0O__"